import { Component, Inject, LOCALE_ID, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { Subscription } from 'rxjs';
import { delay, take, tap, catchError } from 'rxjs/operators';
import { UserService } from '~/auth/services/user/user.service';
import { LoginState } from '~/auth/interface/login-state.interface';

@Component({
  selector: 'app-auth-redirection',
  templateUrl: './redirection.component.html',
})
export class AuthPageRedirectionComponent implements OnInit, OnDestroy {
  private readonly loginInSubscription: Subscription = new Subscription();
  constructor(
    @Inject(LOCALE_ID) private readonly localeId: string,
    private readonly userService: UserService,
    private readonly localizeRouter: LocalizeRouterService,
    private readonly router: Router
  ) {}

  public ngOnDestroy(): void {
    this.loginInSubscription.unsubscribe();
  }

  public ngOnInit(): void {
    // triggered after login success
    this.loginInSubscription.add(
      this.userService.loggedIn$
        .pipe(
          catchError((errors) =>
            errors.pipe(
              delay(3000),
              take(3),
              tap((errorStatus) => {
                // Check error status is gateway response
                if (!errorStatus.toString().startsWith('5')) {
                  console.debug('Connect :: ', errorStatus);
                  this.router.navigateByUrl('/');
                }
                console.debug('Connect : ', errorStatus);
                this.router.navigateByUrl('/');
              })
            )
          )
        )
        .subscribe((loginState: LoginState) => {
          // no state, no actions
          if (!loginState) {
            loginState = {
              from: `/${this.localeId}/`,
              lang: this.localeId,
            };
          }

          // this will change lang for ngx-translate AND ngx-translate-router
          this.localizeRouter.changeLanguage(loginState.lang);

          return this.router.navigateByUrl(loginState.from);
        })
    );
  }
}
